module.exports = __webpack_public_path__ + "img/littleLogo.2d221568.png";